import { create } from "zustand";
import Cookies from "js-cookie";

const cookieOptions = { expires: 90, sameSite: "none", secure: true };

export const useStore = create((set) => ({
  token: "",
  setToken: (newToken) => set((state) => ({ ...state, token: newToken })),
  oneTimeToken: "",
  setOneTimeToken: (newToken) => {
    Cookies.set("ott", newToken, cookieOptions);
    set((state) => ({ ...state, oneTimeToken: newToken }));
  },
  error: "",
  setError: (newToken) => set((state) => ({ ...state, error: newToken })),
  isLoggedIn: JSON.parse(Cookies.get("isLoggedIn") || "false"),
  setIsLoggedIn: (value) => {
    Cookies.set("isLoggedIn", value, cookieOptions);
    set((state) => ({ ...state, isLoggedIn: value }));
  },
  subdomain: localStorage.getItem("subdomain"),
  updateSubdomain: (newSubdomain) => {
    localStorage.setItem("subdomain", newSubdomain);
    Cookies.set("ott", "", cookieOptions);
    Cookies.set("isLoggedIn", false, cookieOptions);
    set((state) => ({ ...state, subdomain: newSubdomain, isLoggedIn: false }));
  },
  status: "",
  setStatus: (newStatus) => set((state) => ({ ...state, status: newStatus })),
}));
